module.exports = __webpack_public_path__ + "img/lincplus_03.25275066.png";